
<template>
  <template v-if="loginType === 'qq'">
    <ImageView
      class="login-type-icon qq-icon"
      :src="qqIcon"
    />
  </template>

  <template v-else-if="loginType === 'wx'">
    <ImageView
      class="login-type-icon wx-icon"
      :src="wxIcon"
    />
  </template>
  <template v-else-if="loginType === 'phone'">
    <ImageView
      class="login-type-icon phone-icon"
      :src="phoneIcon"
    />
  </template>
</template>
<script setup lang="ts">
import ImageView from '@/components/image-view.vue';
import wxIcon from '@/assets/img/wx-icon.png';
import qqIcon from '@/assets/img/qq-icon.png';
import phoneIcon from '@/assets/img/phone-icon.png';


defineProps({
  loginType: {
    type: String,
    default: 'qq',
  },
});

defineExpose();
</script>
<style lang="scss" scoped>
  .qq-icon,
  .wx-icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    margin-right: 4px;
  }

  .phone-icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    margin-right: 4px;
  }

</style>
